import i18n from '@/i18n';

export default {
    params: ['field', 'target'],
    validate: (value, { target }) => value === target,
    message(_, { _rule_, _field_, field }) {
        return i18n.t(`rules.${_rule_}`, {
            field: _field_,
            matching: i18n.t(field).toLowerCase(),
        });
    },
};